import type { FaireProductEntity } from "../../entity_types/product";

export const p_tw3fvzvq4d: FaireProductEntity = {
  token: "p_tw3fvzvq4d",
  type: "product",
  name: "Holding the Evil Eye Heart Charm 18K Gold Plated Necklace",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/798212673cf6c4cd69258f35f55712ac47ec6eb41e6a15aa8e947ac0066fc8d4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31ecfcf744be034bcab605b9b8b8cbd5e58296015cb17758f70db197661004cc.jpeg",
    "https://cdn.faire.com/fastly/e9e446680e2dc3322d130017d6d46296f71625a9d7c839ecdf0d434f84a04b21.jpeg",
    "https://cdn.faire.com/fastly/2286a083b8ffa7fab8076b53996a4072f6cc49569ba1637f477f6ff90b71c2fe.jpeg",
    "https://cdn.faire.com/fastly/a753c988b17dcfd472f714c873214addb1b60d4b55970d5ce71a45460068a5b7.jpeg",
  ],
  priceDollars: 13.08,
  description:
    "Type: pendant necklace\n\nMaterial : Brass，Cubic zirconia，18K Gold plated\n\nSize of pendant ：20mm\n\nSize of chain : 6mm *480mm\n\n★Made of high quality material, Nickel-free / Lead-free， Harmless to Human Body.\n\n★Perfect jewelry gifts",
  tags: [],
  msrpDollars: 36.67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:51.081Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
